const DIALOG_TITLE = {
    liveRead: "Live Reads",
    preRecorded: "Pre-Recorded Spots"
};

const DIALOG_TITLE_SECTION = {
    liveRead: "Enter the advertiser name, keyword, or phrase to search for live reads.",
    preRecorded: "Search playout logs for this advertiser’s pre-recorded spots."
};

const ENABLED_ENGINE_SEARCH = {
    liveRead: { "67cd4dd0-2f75-445d-a6f0-2f297d6cd182": "" },
    preRecorded: { "sdo-search-id": "" }
};

const IMAGES = {
    liveRead: "iconLiveRead",
    preRecorded: "iconRecord"
};

const HEAD_MAPS = {
    advertiser: "Advertiser",
    adName: "Title",
    duration: "Duration",
    lastAired: "Date/Time"
};

const SEARCH_RESULT_HEAD_MAPS = {
    stationName: "Station",
    duration: "Duration",
    lastAired: "Date & Time"
};

const PREVIEW_COUNT = 3;
const GRAPHIQL_SEARCH_LIMIT = 20;


const MERGE_TIME_BETWEEN_TWO_MENTION = 10;
const MERGE_TIME_DELAY_MENTION = 120;
const MERGE_MENTION_WITHOUT_CAT_NAME = "AD";
const MERGE_MENTION_TYPE = {
    SAME_SOURCE: 1, // Step 1: Merge 2 mention same source within 10 seconds
    SAME_SOURCE_WITHOUT_CAT_NAME: 2 // Step 3: Merge 2 mention same source within 2 minutes and without category
};

export default {
    DIALOG_TITLE,
    DIALOG_TITLE_SECTION,
    ENABLED_ENGINE_SEARCH,
    IMAGES,
    HEAD_MAPS,
    SEARCH_RESULT_HEAD_MAPS,
    PREVIEW_COUNT,
    GRAPHIQL_SEARCH_LIMIT,
    MERGE_TIME_BETWEEN_TWO_MENTION,
    MERGE_TIME_DELAY_MENTION,
    MERGE_MENTION_WITHOUT_CAT_NAME,
    MERGE_MENTION_TYPE
};
